import React from 'react';
import P from 'prop-types';

const Cog = ({ fill, className, size }) => {
  return (
    <svg
      className={className}
      style={{
        width: size,
        height: size,
      }}
      viewBox="0 0 20 20"
    >
      <path
        fill={fill}
        d="M19.845 11.747a9.907 9.907 0 0 0 0-3.494l-2.3-.625a7.854 7.854 0 0 0-.533-1.281l1.186-2.07a10.053 10.053 0 0 0-2.474-2.475l-2.071 1.186a7.854 7.854 0 0 0-1.28-.532l-.626-2.3a9.907 9.907 0 0 0-3.494 0l-.625 2.3a7.83 7.83 0 0 0-1.281.532L4.276 1.802a10.06 10.06 0 0 0-2.474 2.474l1.186 2.071c-.215.41-.393.84-.532 1.28l-2.3.626a9.907 9.907 0 0 0 0 3.494l2.3.625c.139.442.317.87.532 1.281l-1.186 2.071c.673.963 1.511 1.8 2.474 2.474l2.071-1.186c.41.215.84.393 1.28.532l.626 2.3a9.907 9.907 0 0 0 3.494 0l.625-2.3a7.83 7.83 0 0 0 1.281-.532l2.07 1.186a10.03 10.03 0 0 0 2.475-2.474l-1.186-2.071c.215-.41.393-.84.532-1.28l2.3-.626zM10 13.721a3.72 3.72 0 1 1 0-7.442 3.72 3.72 0 0 1 0 7.442z"
      />
    </svg>
  );
};

Cog.propTypes = {
  fill: P.string.isRequired,
  className: P.string,
  size: P.number,
};

export default Cog;
